
























import Vue from 'vue'

export default Vue.extend({
  name: 'MoreButtonDropdown',

  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    title: {
      type: String,
      default: 'More options',
    },
    forceVisibility: {
      type: Boolean,
      default: false,
    },
    popperMinWidthSize: {
      type: String,
      default: 'medium',
    },
    verticalEllipsis: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      iconClasses: ['ddi-ellipsis'],
      isOpened: false,
      isRolledOver: false,
    }
  },

  watch: {
    verticalEllipsis: {
      immediate: true,
      handler(val) {
        if (val) {
          this.iconClasses.push('rotate-90')
        }
      },
    },
    forceVisibility(val: boolean) {
      if (val) {
        this.onOpen()
      } else {
        this.onClose()
      }
    },
  },

  methods: {
    updateIconClasses() {
      this.iconClasses = []

      if (this.verticalEllipsis) {
        this.iconClasses.push('rotate-90')
      }
      if (this.isOpened) {
        this.iconClasses.push('dropdown-opened')
        this.iconClasses.push('ddi-ellipsis-filled')
      } else {
        this.iconClasses.push('ddi-ellipsis')

        if (this.isRolledOver) {
          this.iconClasses.push('darkened')
        }
      }
    },
    onOpen() {
      this.isOpened = true
      this.updateIconClasses()
    },
    onClose() {
      this.isOpened = false
      this.updateIconClasses()
    },
    onMouseOver() {
      this.isRolledOver = true
      this.updateIconClasses()
    },
    onMouseLeave() {
      this.isRolledOver = false
      this.updateIconClasses()
    },
  },
})
